import * as actionTypes from './actionTypes';
import * as actions from './index';


export const profileSaveUserStart = () => {
    return {
        type: actionTypes.PROFILE_SAVE_USER_START
    };
};

export const profileSaveUserSuccess = (profile) => {
    return {
        type: actionTypes.PROFILE_SAVE_USER_SUCCESS,
        profile: profile
    };
};

export const profileSaveUserFail = (error) => {
    return {
        type: actionTypes.PROFILE_SAVE_USER_FAIL,
        error: error
    };
};


export const profileGetUserStart = () => {
    return {
        type: actionTypes.PROFILE_GET_USER_START
    };
};

export const profileGetUserSuccess = (profile) => {
    return {
        type: actionTypes.PROFILE_GET_USER_SUCCESS,
        profile: profile
    };
};

export const profileGetUserFail = (error) => {
    return {
        type: actionTypes.PROFILE_GET_USER_FAIL,
        error: error
    };
};


export const profileEditUserStart = () => {
    return {
        type: actionTypes.PROFILE_EDIT_USER_START
    };
};

export const profileEditUserSuccess = (profile) => {
    return {
        type: actionTypes.PROFILE_EDIT_USER_SUCCESS,
        profile: profile
    };
};

export const profileEditUserFail = (error) => {
    return {
        type: actionTypes.PROFILE_EDIT_USER_FAIL,
        error: error
    };
};

export const profileResetError = () => {
    return {
        type: actionTypes.PROFILE_RESET_ERROR
    };
};


export function profileEditUser(profile) {
    window.flow.grantingEditUser(profile.groupid, profile.userid, [
        { 'name': 'uilanguage', 'value': profile.uilanguage },
        { 'name': 'standardview', 'value': profile.standardview },
        { 'name': 'guicolor', 'value': profile.guicolor },
        { 'name': 'notifications', 'value': profile.notifications },
        { 'name': 'vim_accesscode', 'value': profile.vim_accesscode }
    ], true).then((res) => {
        console.log("grantingEditUserSuccess");

    }).catch(res => {
        console.log("grantingEditUserFail");
    });

}

export function profileSetProfile(profile) {
    window.flow.userSetData(profile.userid, { first_name: profile.firstName, last_name: profile.lastName, email: profile.email }).then((res) => {
        console.log("userSetDataSuccess");
        profileEditUser(profile);
    }).catch(res => {
        console.log("userSetDataFail");
    });
}

export function profileSaveUser(profile) {

    return dispatch => {
        if (profile.changePassword) {
            window.flow.userSetPassword(profile.userid, profile.password).then((res) => {
                console.log("savePasswordSuccess");
                dispatch(profileSaveUserSuccess(profile));
                profileSetProfile(profile);

            }).catch(res => {
                console.log("profileSavePasswordFail", res.message);
                dispatch(profileSaveUserFail(res));
            });
        } else {
            profileSetProfile(profile);
        }

    }

} 
